module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-tree', {
    ref: "tree",
    attrs: {
      "data": _vm.data,
      "load": _vm.loadNode1,
      "filter-node-method": _vm.filterNode,
      "filterText": _vm.filterText,
      "node-key": "id",
      "empty-text": " ",
      "default-checked-keys": _vm.defaultChecked,
      "show-checkbox": _vm.showCheckBox
    },
    on: {
      "node-click": _vm.treeNodeClick,
      "check-change": _vm.handleCheckChange
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-32f4186c","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/tree/tree.vue
// module id = 549
// module chunks = 1 2 3 4 5 6 7 8